module.exports = __webpack_public_path__ + "img/veronica-mariani.b6dd0af6.jpg";